/**
 * The26 theme frontend interactions (from HTML_TEMPLATES/script.js)
 */
(function () {
  const html = document.documentElement;
  const themeToggle = document.getElementById("theme-toggle");
  const menuToggle = document.getElementById("menu-toggle");
  const mobileNav = document.getElementById("mobile-nav");
  const scheme = html.getAttribute("data-theme-scheme") || "default";
  const canToggle = scheme === "default";

  function applyTheme(dark, persist) {
    html.classList.toggle("dark", dark);
    if (dark) html.setAttribute("data-scheme", "dark");
    else html.removeAttribute("data-scheme");
    if (persist && canToggle) {
      localStorage.setItem("theme", dark ? "dark" : "light");
      document.cookie =
        "darkmode=" +
        (dark ? "1" : "") +
        ";path=/;max-age=" +
        (dark ? 31536000 : 0) +
        ";SameSite=Lax";
    }
    html.classList.toggle("c_darkmode", dark);
    themeToggle?.setAttribute("aria-pressed", String(dark));
    themeToggle?.querySelector("[data-icon-light]")?.classList.toggle("hidden", dark);
    themeToggle?.querySelector("[data-icon-dark]")?.classList.toggle("hidden", !dark);
    document.querySelectorAll("[data-theme-checkbox]").forEach((el) => {
      el.checked = dark;
    });
  }

  if (canToggle) {
    themeToggle?.addEventListener("click", () => {
      applyTheme(!html.classList.contains("dark"), true);
    });
    document.querySelectorAll("[data-theme-checkbox]").forEach((el) => {
      el.addEventListener("change", () => applyTheme(el.checked, true));
    });
    applyTheme(html.classList.contains("dark"), true);
  } else if (scheme === "auto") {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    applyTheme(mq.matches, false);
    mq.addEventListener("change", (e) => applyTheme(e.matches, false));
  } else {
    applyTheme(scheme === "darkmode", false);
  }

  function setMenu(open) {
    mobileNav?.classList.toggle("hidden", !open);
    menuToggle?.setAttribute("aria-expanded", String(open));
    menuToggle?.querySelector("[data-icon-open]")?.classList.toggle("hidden", open);
    menuToggle?.querySelector("[data-icon-close]")?.classList.toggle("hidden", !open);
  }

  menuToggle?.addEventListener("click", () => {
    setMenu(mobileNav?.classList.contains("hidden"));
  });

  mobileNav?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setMenu(false);
      closeAllDropdowns();
    }
  });

  // Account avatar dropdown (click to open — AppUI is not on the marketing layout)
  const accountDropdown = document.querySelector("[data-account-dropdown]");
  const accountTrigger = accountDropdown?.querySelector("[data-account-dropdown-trigger]");
  const accountPanel = accountDropdown?.querySelector("[data-account-dropdown-panel]");

  function setAccountOpen(open) {
    if (!accountDropdown || !accountTrigger || !accountPanel) return;
    accountPanel.classList.toggle("hidden", !open);
    accountTrigger.setAttribute("aria-expanded", String(open));
  }

  accountTrigger?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAccountOpen(accountPanel.classList.contains("hidden"));
  });

  accountPanel?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setAccountOpen(false));
  });

  const dropdowns = document.querySelectorAll("[data-nav-dropdown]");
  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  function closeAllDropdowns() {
    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove("is-open");
      dropdown.querySelector("[data-nav-dropdown-trigger]")?.setAttribute("aria-expanded", "false");
    });
    setAccountOpen(false);
  }

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector("[data-nav-dropdown-trigger]");
    const panel = dropdown.querySelector("[data-nav-dropdown-panel]");
    if (!trigger || !panel) return;

    let closeTimer;

    function setOpen(open) {
      clearTimeout(closeTimer);
      dropdown.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", String(open));
    }

    if (canHover) {
      dropdown.addEventListener("mouseenter", () => setOpen(true));
      dropdown.addEventListener("mouseleave", () => {
        closeTimer = setTimeout(() => setOpen(false), 120);
      });
    }

    trigger.addEventListener("click", (event) => {
      if (canHover) return;
      event.stopPropagation();
      const open = !dropdown.classList.contains("is-open");
      closeAllDropdowns();
      if (open) setOpen(true);
    });

    panel.querySelectorAll("a[href^='#']").forEach((link) => {
      link.addEventListener("click", () => setOpen(false));
    });

    dropdown.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        trigger.focus();
      }
    });
  });

  document.addEventListener("click", (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("is-open");
        dropdown.querySelector("[data-nav-dropdown-trigger]")?.setAttribute("aria-expanded", "false");
      }
    });
    if (accountDropdown && !accountDropdown.contains(event.target)) {
      setAccountOpen(false);
    }
  });

  const mobileProductsTrigger = document.querySelector("[data-mobile-products-trigger]");
  const mobileProductsPanel = document.getElementById("mobile-products-panel");
  const mobileProductsChevron = document.querySelector("[data-mobile-products-chevron]");

  mobileProductsTrigger?.addEventListener("click", () => {
    const open = mobileProductsPanel?.classList.toggle("hidden") === false;
    mobileProductsTrigger.setAttribute("aria-expanded", String(open));
    mobileProductsChevron?.classList.toggle("rotate-180", open);
  });

  mobileProductsPanel?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  const mobileResourcesTrigger = document.querySelector("[data-mobile-resources-trigger]");
  const mobileResourcesPanel = document.getElementById("mobile-resources-panel");
  const mobileResourcesChevron = document.querySelector("[data-mobile-resources-chevron]");

  mobileResourcesTrigger?.addEventListener("click", () => {
    const open = mobileResourcesPanel?.classList.toggle("hidden") === false;
    mobileResourcesTrigger.setAttribute("aria-expanded", String(open));
    mobileResourcesChevron?.classList.toggle("rotate-180", open);
  });

  mobileResourcesPanel?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  const mobileLanguagesTrigger = document.querySelector("[data-mobile-languages-trigger]");
  const mobileLanguagesPanel = document.getElementById("mobile-languages-panel");
  const mobileLanguagesChevron = document.querySelector("[data-mobile-languages-chevron]");

  mobileLanguagesTrigger?.addEventListener("click", () => {
    const open = mobileLanguagesPanel?.classList.toggle("hidden") === false;
    mobileLanguagesTrigger.setAttribute("aria-expanded", String(open));
    mobileLanguagesChevron?.classList.toggle("rotate-180", open);
  });

  mobileLanguagesPanel?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  // Simple modal open/close
  document.querySelectorAll("[data-open-modal]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const modal = document.getElementById(btn.getAttribute("data-open-modal"));
      if (!modal) return;
      modal.classList.remove("hidden");
      modal.classList.add("flex");
      modal.setAttribute("aria-hidden", "false");
    });
  });

  document.querySelectorAll("[data-close-modal]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const modal = document.getElementById(btn.getAttribute("data-close-modal"));
      if (!modal) return;
      modal.classList.add("hidden");
      modal.classList.remove("flex");
      modal.setAttribute("aria-hidden", "true");
    });
  });

  // Advanced shorten fields toggle
  document.querySelectorAll("[data-toggle-advanced]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const panel = document.getElementById(btn.getAttribute("aria-controls") || "advanced");
      if (!panel) return;
      const open = panel.classList.toggle("hidden") === false;
      btn.setAttribute("aria-expanded", String(open));
    });
  });

  document.querySelectorAll(".pricing-container [data-pricing]").forEach(function(btn) {
    btn.addEventListener("click", function() {
        var term = btn.getAttribute("data-pricing");
        var container = btn.closest(".pricing-container");
        if (!container || btn.classList.contains("bg-white")) return;
        container.querySelectorAll("[data-pricing]").forEach(function(b) {
            b.classList.remove("bg-white", "text-black", "shadow-sm");
            b.classList.add("text-black/60", "dark:text-white/60");
        });
        btn.classList.add("bg-white", "text-black", "shadow-sm");
        btn.classList.remove("text-black/60", "dark:text-white/60");
        container.querySelectorAll("[data-pricing-" + term + "]").forEach(function(el) {
            var price = el.getAttribute("data-pricing-" + term);
            if (!price) return;
            var priceEl = el.querySelector(".price");
            if (priceEl) priceEl.textContent = price;
            else if (el.classList.contains("price")) el.textContent = price;
        });
        container.querySelectorAll("[data-toggle=pricingterm]").forEach(function(el) {
            var t = el.getAttribute("data-term-" + term);
            if (t) el.textContent = t;
        });
        container.querySelectorAll("[data-toggle=discount]").forEach(function(el) {
            el.classList.toggle("hidden", term !== "yearly");
        });
        container.querySelectorAll("a.checkout, a[data-trigger=checkout]").forEach(function(link) {
            var href = link.getAttribute("href");
            if (href && href !== "#") {
                var target = new URL(href, document.baseURI);
                target.pathname = target.pathname.replace(/\/(monthly|yearly|lifetime)\/?$/, "/" + term);
                link.setAttribute("href", target.href);
            }
        });
    });
  });

  // Link shortener card hover demo
  (function () {
    const article = document.getElementById("link-shortener");
    const demo = article?.querySelector("[data-shortener-demo]");
    if (!article || !demo) return;

    const SPINNER_MS = 500;
    let timer;

    const reset = () => {
      clearTimeout(timer);
      demo.classList.remove("is-loading", "is-expanded");
    };

    const play = () => {
      reset();
      demo.classList.add("is-loading");
      timer = setTimeout(() => {
        demo.classList.remove("is-loading");
        demo.classList.add("is-expanded");
      }, SPINNER_MS);
    };

    article.addEventListener("mouseenter", play);
    article.addEventListener("mouseleave", reset);
  })();

  // Link-in-bio card hover demo
  (function () {
    const article = document.getElementById("link-in-bio");
    const demo = article?.querySelector("[data-bio-demo]");
    if (!article || !demo) return;

    const STEP_MS = 350;
    const timers = [];

    const reset = () => {
      timers.forEach(clearTimeout);
      timers.length = 0;
      demo.classList.remove("is-step-2", "is-step-3", "is-complete");
    };

    const play = () => {
      reset();
      timers.push(setTimeout(() => demo.classList.add("is-step-2"), STEP_MS));
      timers.push(setTimeout(() => demo.classList.add("is-step-3"), STEP_MS * 2));
      timers.push(setTimeout(() => demo.classList.add("is-complete"), STEP_MS * 3));
    };

    article.addEventListener("mouseenter", play);
    article.addEventListener("mouseleave", reset);
  })();

  // Social login — remember last used provider
  (function () {
    const KEY = "social_login_last_used";
    const containers = document.querySelectorAll("[data-social-login]");
    if (!containers.length) return;

    let last = null;
    try {
      last = localStorage.getItem(KEY);
    } catch (e) {}

    containers.forEach((container) => {
      const label = container.getAttribute("data-last-used-label") || "Last used";
      const buttons = Array.from(container.querySelectorAll("[data-social-provider]"));
      if (!buttons.length) return;

      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          try {
            localStorage.setItem(KEY, btn.getAttribute("data-social-provider"));
          } catch (e) {}
        });
      });

      if (!last) return;

      const match = buttons.find((btn) => btn.getAttribute("data-social-provider") === last);
      if (!match) return;

      container.insertBefore(match, container.firstChild);

      if (match.querySelector("[data-social-last-used]")) return;

      const badge = document.createElement("span");
      badge.textContent = label;
      badge.setAttribute("data-social-last-used", "1");
      match.appendChild(badge);
    });
  })();

  // API docs — language tabs, copy, sidebar, LLM dropdowns
  (function () {
    const docs = document.getElementById("apidocs");
    if (!docs) return;

    docs.querySelectorAll(".code-area").forEach((area) => {
      const buttons = area.querySelectorAll(".code-lang-btn");
      const panels = area.querySelectorAll(".code-selector");
      if (!buttons.length || !panels.length) return;

      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const lang = btn.getAttribute("data-lang");
          buttons.forEach((b) => b.classList.toggle("is-active", b === btn));
          panels.forEach((panel) => {
            panel.hidden = panel.getAttribute("data-id") !== lang;
          });
        });
      });
    });

    docs.querySelectorAll("[data-trigger=copycode]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const area = btn.closest(".code-area");
        const active = area?.querySelector(".code-selector:not([hidden]) pre, .code-selector:not([hidden]) code, pre.code");
        const text = (active?.innerText || active?.textContent || "").trim();
        if (!text) return;
        try {
          await navigator.clipboard.writeText(text);
          btn.classList.add("text-emerald-400");
          setTimeout(() => btn.classList.remove("text-emerald-400"), 1200);
        } catch (e) {}
      });
    });

    const sidebar = document.getElementById("api-sidebar");
    const sidebarToggle = document.getElementById("api-sidebar-toggle");
    const sidebarClose = document.getElementById("api-sidebar-close");
    const sidebarBackdrop = document.getElementById("api-sidebar-backdrop");

    function setSidebarOpen(open) {
      if (!sidebar) return;
      sidebar.classList.toggle("is-open", open);
      sidebar.classList.toggle("-translate-x-full", !open);
      sidebar.classList.toggle("translate-x-0", open);
      sidebarBackdrop?.classList.toggle("hidden", !open);
      sidebarToggle?.setAttribute("aria-expanded", String(open));
      sidebarToggle?.classList.toggle("opacity-0", open);
      sidebarToggle?.classList.toggle("pointer-events-none", open);
      document.body.classList.toggle("overflow-hidden", open && window.innerWidth < 1024);
      if (open) sidebarClose?.focus();
    }

    sidebarToggle?.addEventListener("click", () => {
      setSidebarOpen(!sidebar?.classList.contains("is-open"));
    });
    sidebarClose?.addEventListener("click", () => setSidebarOpen(false));
    sidebarBackdrop?.addEventListener("click", () => setSidebarOpen(false));
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && sidebar?.classList.contains("is-open")) {
        setSidebarOpen(false);
        sidebarToggle?.focus();
      }
    });
    sidebar?.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        if (window.innerWidth < 1024) setSidebarOpen(false);
      });
    });

    document.querySelectorAll("[data-trigger=scrollto]").forEach((link) => {
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href");
        if (!href || href.charAt(0) !== "#") return;
        const target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        const offset = parseInt(link.getAttribute("data-scrollto-offset") || "100", 10);
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
        history.replaceState(null, "", href);
      });
    });

    document.querySelectorAll("[data-llm-dropdown]").forEach((dropdown) => {
      const trigger = dropdown.querySelector("[data-llm-dropdown-trigger]");
      const panel = dropdown.querySelector("[data-llm-dropdown-panel]");
      if (!trigger || !panel) return;

      trigger.addEventListener("click", (event) => {
        event.stopPropagation();
        const open = panel.classList.toggle("hidden") === false;
        trigger.setAttribute("aria-expanded", String(open));
      });

      document.addEventListener("click", (event) => {
        if (!dropdown.contains(event.target)) {
          panel.classList.add("hidden");
          trigger.setAttribute("aria-expanded", "false");
        }
      });
    });
  })();

  // Affiliate live sales toasts
  (function initAffiliateSales() {
    const root = document.getElementById("affiliate-sales");
    if (!root) return;
    const stack = root.querySelector("[data-sales-stack]");
    if (!stack) return;

    let items = [];
    try {
      items = JSON.parse(root.getAttribute("data-items") || "[]");
    } catch (_) {
      return;
    }
    if (!items.length) return;

    const earnedLabel = root.getAttribute("data-earned-label") || "earned";
    let i = 0;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function toast(item) {
      const el = document.createElement("div");
      el.className =
        "affiliate-sale-toast flex items-center gap-3 rounded-xl bg-white/90 backdrop-blur shadow-lg shadow-black/10 ring-1 ring-black/5 px-3.5 py-3";
      el.innerHTML =
        '<span class="flex size-10 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-[11px] font-bold text-white">' +
        item.initials +
        "</span>" +
        '<div class="min-w-0 flex-1">' +
        '<p class="text-sm font-semibold text-black truncate">' +
        item.name +
        ' <span class="font-normal text-black/50">' +
        earnedLabel +
        "</span></p>" +
        '<p class="text-xs text-black/45 truncate">' +
        item.place +
        "</p>" +
        "</div>" +
        '<span class="shrink-0 text-sm font-bold tabular-nums text-emerald-700">' +
        item.amount +
        "</span>";
      return el;
    }

    function push() {
      stack.prepend(toast(items[i % items.length]));
      while (stack.children.length > 4) stack.removeChild(stack.lastElementChild);
      i++;
    }

    push();
    push();
    push();
    if (!reduceMotion) setInterval(push, 2600);
  })();

  // Public QR generator (#qr-generator)
  (function () {
    const form = document.getElementById("qr-generator");
    if (!form) return;

    const activeClass =
      "inline-flex items-center rounded-lg bg-black text-white dark:bg-white dark:text-black px-3 py-1.5 text-xs font-semibold mb-2 mr-1";
    const inactiveClass =
      "inline-flex items-center rounded-lg border border-black/10 dark:border-white/10 px-3 py-1.5 text-xs font-medium text-black/60 dark:text-white/60 hover:bg-black/5 dark:hover:bg-white/5 transition-colors mb-2 mr-1";
    const tabs = Array.from(form.querySelectorAll("[data-qr-type]"));
    const panels = Array.from(form.querySelectorAll("[data-qr-panel]"));
    const typeInput = form.querySelector('input[name="type"]');
    const preview = document.getElementById("return-ajax");

    function notify(message, type) {
      const styles = {
        danger: "bg-red-600 text-white",
        success: "bg-emerald-600 text-white",
        info: "bg-neutral-900 text-white dark:bg-white dark:text-neutral-900",
      };
      const scripts = [];
      const text = String(message || "")
        .replace(/<script\b[^>]*>([\s\S]*?)<\/script>/gi, (_, code) => {
          scripts.push(code);
          return "";
        })
        .replace(/<[^>]+>/g, "")
        .replace(/\s+/g, " ")
        .trim();
      scripts.forEach((code) => {
        if (!String(code || "").trim()) return;
        try {
          const s = document.createElement("script");
          s.text = code;
          document.head.appendChild(s);
          document.head.removeChild(s);
        } catch (err) {}
      });
      if (!text) return;
      const el = document.createElement("div");
      el.setAttribute("role", "alert");
      el.className =
        "fixed z-[1080] top-0 right-0 m-4 max-w-sm rounded-lg px-4 py-3 text-sm shadow-lg " +
        (styles[type] || styles.info);
      el.textContent = text;
      document.body.appendChild(el);
      setTimeout(() => {
        el.style.transition = "opacity 200ms";
        el.style.opacity = "0";
        setTimeout(() => el.remove(), 200);
      }, 4000);
    }

    function selectType(type) {
      if (!type) return;
      tabs.forEach((tab) => {
        const on = tab.getAttribute("data-qr-type") === type;
        tab.className = on ? activeClass : inactiveClass;
        tab.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach((panel) => {
        const on = panel.getAttribute("data-qr-panel") === type;
        panel.classList.toggle("hidden", !on);
        panel.hidden = !on;
      });
      if (typeInput) typeInput.value = type;
    }

    form.addEventListener("click", (e) => {
      const tab = e.target.closest("[data-qr-type]");
      if (tab && form.contains(tab)) {
        e.preventDefault();
        selectType(tab.getAttribute("data-qr-type"));
        return;
      }
      const toggle = e.target.closest("[data-qr-toggle]");
      if (toggle && form.contains(toggle)) {
        e.preventDefault();
        const target = form.querySelector(toggle.getAttribute("data-qr-toggle"));
        if (!target) return;
        const open = target.classList.toggle("hidden") === false;
        target.hidden = !open;
      }
    });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const submit = form.querySelector('button[type="submit"]');
      const label = submit ? submit.textContent : "";
      if (submit) {
        submit.disabled = true;
        submit.innerHTML =
          '<svg class="size-4 animate-spin" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';
      }

      try {
        const res = await fetch(form.getAttribute("action"), {
          method: "POST",
          body: new FormData(form),
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        const response = await res.json();
        document.querySelectorAll('input[name="_token"]').forEach((el) => {
          if (response.token) el.value = response.token;
        });
        if (response.error) {
          notify(response.message, "danger");
        } else {
          notify(response.message, "success");
          if (response.html && preview) preview.innerHTML = response.html;
        }
      } catch (err) {
        notify("Something went wrong. Please try again.", "danger");
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = label;
        }
      }
    });

    form.querySelectorAll("[data-trigger=saveqr]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const img = preview && preview.querySelector("img");
        const svgdata = img && img.getAttribute("src");
        if (!svgdata) return;

        const format = btn.getAttribute("data-format") || "svg";

        if (format === "svg") {
          const a = document.createElement("a");
          a.download = "QRCode.svg";
          a.href = svgdata;
          document.body.appendChild(a);
          a.click();
          a.remove();
          return;
        }

        let svg = "";
        try {
          svg = atob(svgdata.replace("data:image/svg+xml;base64,", ""));
        } catch (err) {
          return;
        }
        svg = svg
          .replace('<?xml version="1.0" encoding="UTF-8"?>', "")
          .replace(
            '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">',
            ""
          );
        const url = URL.createObjectURL(
          new Blob([svg], { type: "image/svg+xml;charset=utf-8" })
        );
        const raster = new Image();
        raster.addEventListener("load", () => {
          const canvas = document.createElement("canvas");
          canvas.width = 1000;
          canvas.height = 1000;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(raster, 0, 0, 1000, 1000);
          URL.revokeObjectURL(url);
          const a = document.createElement("a");
          a.download = format === "webp" ? "QRcode.webp" : "QRcode.png";
          a.href = canvas.toDataURL(format === "webp" ? "image/webp" : "image/png");
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
        raster.src = url;
      });
    });
  })();

  // Homepage feature slider — auto-advancing tabs
  (function () {
    const slider = document.querySelector("[data-feature-slider]");
    const tabsList = slider?.querySelector("[data-feature-tabs]");
    if (!slider || !tabsList) return;

    const visuals = slider.querySelectorAll("[data-feature-visual]");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const tabs = () => Array.from(tabsList.querySelectorAll("[data-feature-tab]"));

    const activate = (id) => {
      tabs().forEach((tab) => {
        const on = tab.getAttribute("data-feature-tab") === id;
        tab.classList.toggle("is-active", on);
        tab.setAttribute("aria-selected", String(on));
        tab.tabIndex = on ? 0 : -1;
      });
      visuals.forEach((panel) => {
        panel.classList.toggle("is-active", panel.getAttribute("data-feature-visual") === id);
      });
    };

    const advance = () => {
      const list = tabs();
      const i = list.findIndex((tab) => tab.classList.contains("is-active"));
      if (i < 0) return;
      const next = list[(i + 1) % list.length];
      if (!next) return;
      activate(next.getAttribute("data-feature-tab"));
    };

    tabsList.addEventListener("click", (e) => {
      const tab = e.target.closest("[data-feature-tab]");
      if (!tab || tab.classList.contains("is-active")) return;
      activate(tab.getAttribute("data-feature-tab"));
    });

    tabsList.addEventListener("keydown", (e) => {
      const list = tabs();
      const i = list.findIndex((tab) => tab.classList.contains("is-active"));
      if (i < 0) return;
      let next = null;
      if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        next = list[(i + 1) % list.length];
      } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
        next = list[(i - 1 + list.length) % list.length];
      } else if (e.key === "Home") {
        next = list[0];
      } else if (e.key === "End") {
        next = list[list.length - 1];
      }
      if (!next) return;
      e.preventDefault();
      next.focus();
      activate(next.getAttribute("data-feature-tab"));
    });

    if (!reduced) {
      tabsList.addEventListener("animationend", (e) => {
        if (e.animationName !== "feature-tab-progress") return;
        const tab = e.target.closest("[data-feature-tab]");
        if (!tab?.classList.contains("is-active")) return;
        advance();
      });

      const io = new IntersectionObserver(
        ([entry]) => {
          slider.classList.toggle("is-paused", !entry.isIntersecting);
        },
        { threshold: 0.35 }
      );
      io.observe(slider);
    }
  })();

  // Simple input masks via data-mask (e.g. data-mask="000 000")
  // "0" accepts letters and digits; other mask chars are literals
  document.querySelectorAll("[data-mask]").forEach(function (input) {
    var pattern = input.getAttribute("data-mask") || "";
    if (!pattern) return;
    input.setAttribute("maxlength", String(pattern.length));
    input.addEventListener("input", function () {
      var chars = input.value.replace(/[^a-zA-Z0-9]/g, "");
      var out = "";
      var ci = 0;
      for (var i = 0; i < pattern.length && ci < chars.length; i++) {
        out += pattern[i] === "0" ? chars[ci++] : pattern[i];
      }
      input.value = out;
    });
  });

  // Cookie consent (vanilla-cookieconsent). Library is loaded after this file in some layouts.
  (function initCookieBanner() {
    var started = false;

    function run() {
      if (started) return;
      if (typeof initCookieConsent !== "function") return;
      if (typeof lang === "undefined" || !lang.cookie) return;
      started = true;

      if (html.classList.contains("dark")) {
        html.classList.add("c_darkmode");
      }

      var cc = initCookieConsent();
      cc.run({
        current_lang: "app",
        autoclear_cookies: true,
        cookie_name: "cc_cookie",
        cookie_expiration: 365,
        page_scripts: true,
        autorun: true,
        languages: {
          app: {
            consent_modal: {
              title: lang.cookie.title,
              description: lang.cookie.description + lang.cookie.button,
              primary_btn: {
                text: lang.cookie.accept_all,
                role: "accept_all",
              },
              secondary_btn: {
                text: lang.cookie.accept_necessary,
                role: "accept_necessary",
              },
            },
            settings_modal: {
              title: lang.cookie.title,
              save_settings_btn: lang.cookie.save,
              accept_all_btn: lang.cookie.accept_all,
              reject_all_btn: lang.cookie.accept_necessary,
              close_btn_label: lang.cookie.close,
              blocks: [
                {
                  description: lang.cookie.description,
                },
                {
                  title: lang.cookie.necessary.title,
                  description: lang.cookie.necessary.description,
                  toggle: {
                    value: "necessary",
                    enabled: true,
                    readonly: true,
                  },
                },
                {
                  title: lang.cookie.analytics.title,
                  description: lang.cookie.analytics.description,
                  toggle: {
                    value: "analytics",
                    enabled: false,
                    readonly: false,
                  },
                },
                {
                  title: lang.cookie.ads.title,
                  description: lang.cookie.ads.description,
                  toggle: {
                    value: "ads",
                    enabled: false,
                    readonly: false,
                  },
                },
                {
                  title: lang.cookie.extra.title,
                  description: lang.cookie.extra.description,
                  toggle: {
                    value: "extra",
                    enabled: false,
                    readonly: false,
                  },
                },
                {
                  title: lang.cookie.privacy.title,
                  description: lang.cookie.privacy.description,
                },
              ],
            },
          },
        },
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run);
    } else {
      run();
    }
  })();
})();
